import listApiCall from './list';
import detailApiCall from './detail';
import createApiCall from './create';
import editApiCall from './edit';
import backfillMarketValueApiCall from './backfillMarketValue';
import syncCashBalanceApiCall from './syncCashBalance';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  create: createApiCall,
  edit: editApiCall,
  backfillMarketValue: backfillMarketValueApiCall,
  syncCashBalance: syncCashBalanceApiCall,
};

export default ApiCall;
